<template>
  <div>
    <div style="height: 10%;">
      <img src="../../static/img/ejymjpg.png" style="width: 100%; height: 100%;">
    </div>
    <div class="btcss">
<!--      <div class="tabbox">
        <div  :class="{'active':active_btn==index}"  v-for="(item,index) in titleList" @click="newsList(index)">{{item.name}}</div>
      </div>-->
      <div class="dqwz">首页 > 产品世界 > {{ detailData.menuName }} > {{ detailData.productName }}</div>
    </div>
    <!-- 头部 -->
    <div class="ceneterbox">
        <!-- 产品轮播图 -->
        <div class="cpb">
          <div class="block">
            <div>
              <div>
                <img :src="api + mainImgUrl" id="imagescroll" style="height:400px;width:100%;object-fit: cover;"
                     @mouseenter="enterHandler" @mousemove="moveHandler" @mouseout="outHandler">
              </div>
              <h2>{{detailData.productModel}}<br>
              {{ detailData.productName }}</h2>
                <i style="font-size: 30px;display: inline-block;position: relative;top: 62px;cursor: pointer;"
                   class="el-icon-arrow-left"
                   @click="imgLeft()"></i>
                <ul class="Img_ul">
                  <li v-for="(item,index) in imgUrlList" :key="index" class="Img_li" :style="imgStyle"
                      @click="changeImg(item, index)">
                    <img :class="index === imgActiveIndex ? 'img_activeBorder' : ''" :src="api + item"
                         style="width:50px;height:50px">
                  </li>
                </ul>
                <i style="font-size: 30px;display: inline-block;position: relative;left: 96% ;top: -50px;cursor: pointer;"
                   class="el-icon-arrow-right"
                   @click="imgRight()"></i>
            </div>
          </div>
          <!-- 意向表单 -->
          <div class="biaodan">
            <el-form :model="searchForm" :rules="rules" ref="searchForm" label-width="100px" class="demo-ruleForm">
              <div v-html="detailData.skillParam" style="height: 475px;overflow: auto" class="HTMLCSS">
<!--                <p class="pleft">性能特点&nbsp;&nbsp;&nbsp;{{ detailData.performanceFeature }}</p>-->
<!--              <p class="pleft">使用范围&nbsp;&nbsp;&nbsp;{{ detailData.usableRange }}</p>-->
<!--              <p class="pleft">使用温度&nbsp;&nbsp;&nbsp;{{ detailData.usageTemperature }}</p>-->
<!--              <p class="pleft">产品规格&nbsp;&nbsp;&nbsp;{{ detailData.productStandard }}</p>-->

              </div>
              <div style="padding: 60px 0;">
                <el-row :gutter="24">
                  <el-col :span="12">
                    <el-button type="success" @click="openBuy()">立即购买</el-button>
                  </el-col>
                  <el-col :span="12">
                    <el-button type="success" @click="openUrl()">返回列表</el-button>
                  </el-col>
                </el-row>
              </div>
            </el-form>
          </div>
        </div>
        <div class="cpxq">
          <template>
<!--            <div class="cpxqbox">产品详情</div>-->
            <div v-html="detailData.productParam"></div>
          </template>
        </div>
    </div>

    <el-dialog title="立即购买" :visible.sync="bugDialog" width="40%">
      <el-form :model="buyForm" :rules="rules" ref="buyForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="联系方式" prop="phone">
          <el-input v-model="buyForm.phone" :maxlength="11" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-input v-model="buyForm.content" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <el-input v-model="buyForm.code" style="width: calc(100% - 200px)" class="yzmbiaodan"></el-input>
          <div style="float: right;"><img ref="vcImg" :src="api + '/site/captchaImage?uuid=' + 1" alt="验证码"
                                          @click="getVerifyCode()" style="width: 140px;"/></div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="buyAdd('buyForm')" size="">立即购买</el-button>
          <el-button @click="handleClose('buyForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="神力胶业集团" :visible.sync="zxDialog" width="24%" class="zxbox" :modal="false">
      <div slot="title" class="dialog-header-title">
        <div><img src="../../static/img/zxtTitle.png" style="width: 50px;"/></div>
        <div class="zxname">神力胶业集团</div>
      </div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="top" label-width="100px"
               class="demo-ruleForm">
        <el-form-item label="*您的联系方式？" prop="name">
          <el-input type="textarea" v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label=" " prop="desc">
          <el-input type="textarea" v-model="ruleForm.desc" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="SubmitForm('ruleForm')">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>


  </div>
</template>
<script>
import {api,deptId} from '@/config.js';
export default {
  name: 'Cpdetails',
  data() {
    return {
      titleList:[
        {name:'走进神力'},
        {name:'郑重声明'},
        {name:'齐全的荣誉证照'},
        {name:'完善的资质证书'},
        {name:'企业规划优势'},
        {name:'招商优惠政策'},
      ],
      active_btn:0,
      columnId: '',
      topStyle: {
        transform: ""
      },
      r_img: {},
      topShow: false,
      rShow: false,
      mainImgUrl: '',
      imgUrlList: [],
      imgActiveIndex: 0, // 当前移动图片的索引值
      imgDistance: 0, // 移动的距离
      allDistance: 0, // 总移动距离
      activeName: 'first',
      // options: [{
      //   value: '选项1',
      //   label: '黄金糕'
      // },],
      ruleForm: {},
      detailData: {

      },
      value: '',
      input3: '',
      name: '',
      visible: false,
      api,
      activeIndex: '1',
      activeIndex2: '1',
      form: {},
      buyForm: {},
      rules: {},
      columnData: [],
      outsideList: [],
      searchForm: {},
      zxDialog: false,
      bugDialog: false,
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        type: '',
        gjz: '',
      },
      listData: [],
    }
  },
  computed: {
    imgStyle() {
      return {
        transform: `translate3d(${this.imgDistance}px, 0, 0)` // 计算移动的距离(x,y,z)
      }
    }
  },
  mounted() {
    this.lmList(),
        this.wlList()
    this.detailList()
    this.zxSubmit()
    this.name = this.$route.query.name
    // console.log(11112,  this.$route.query.id);
  },
  created() {

  },
  methods: {
    newsList(index){
      this.active_btn = index
    },
    //跳转产品详情页面
    openDetails(item) {
      window.location = "/#/cpDetails?id=" + item.productId + '&name=' + encodeURI(item.productName)
    },
    //立即购买
    buyAdd() {
      let that = this;
      that.$axios.post(api + '/site/productBuy?code=' + that.buyForm.code + '&content=' + that.buyForm.content + '&deptId=' + deptId
          + '&phone=' + that.buyForm.phone + '&productId=' + that.detailData.productId, {
        emulateJSON: true
      }).then(function (res) {
        // console.log('GOUM', res.data);
        if (res.data.code == '0') {
          that.$message.message(res.data.msg);
          this.bugDialog = false
          // console.log(111, res.data);
        } else if (res.data.code == '412') {
          that.$message.error(res.data.msg);
          that.getVerifyCode()
        } else {
          that.$message.error(res.data.msg);
        }
      })
    },
    //购买弹窗
    openBuy() {
      this.bugDialog = true
      // this.getYzm()

    },
    // 重新获取表单验证码
    getVerifyCode() {
      // 直接通过src去请求验证码图片 通过Math.random()防止缓存问题
      this.$refs.vcImg.src = api + '/site/captchaImage?uuid=' + 1 + Math.random()
    },
    //产品详情
    detailList() {
      let that = this;
      that.$axios.post(api + '/site/productDetail?productId=' + this.$route.query.id + '&columnId=' + this.columnId, {
        emulateJSON: true
      }).then(function (res) {
        if (res.data.code == '0') {
          if (res.data.data) {
            that.detailData = res.data.data
            that.imgUrlList = res.data.data.photos
            that.mainImgUrl = res.data.data.photos[0]
            console.log('详情', res.data.data)
          }
        } else {
          that.$message.error(res.message);
        }
      })
    },
    GetQueryString(str) {
      var reg = new RegExp("(^|&)" + str + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return decodeURI(r[2]);
      return null;
    },
    // 鼠标进入原图空间函数
    enterHandler() {
      // 层罩及放大空间的显示
      this.topShow = true;
      this.rShow = true;
    },
    // 鼠标移动函数
    moveHandler(event) {
      // 鼠标的坐标位置
      let x = event.offsetX;
      let y = event.offsetY;
      // 层罩的左上角坐标位置，并对其进行限制：无法超出原图区域左上角
      let topX = x - 100 < 0 ? 0 : x - 100;
      let topY = y - 100 < 0 ? 0 : y - 100;
      // 对层罩位置再一次限制，保证层罩只能在原图区域空间内
      if (topX > 200) {
        topX = 200;
      }
      if (topY > 200) {
        topY = 200;
      }
      // 通过 transform 进行移动控制
      this.topStyle.transform = `translate(${topX}px,${topY}px)`;
      this.r_img.transform = `translate(-${2 * topX}px,-${2 * topY}px)`;
    },
    // 鼠标移出函数
    outHandler() {
      // 控制层罩与放大空间的隐藏
      this.topShow = false;
      this.rShow = false;
    },
    changeImg(item, index) {
      this.mainImgUrl = item
      this.imgActiveIndex = index
    },
    imgLeft() {
      if (this.imgActiveIndex > 0) {
        this.imgActiveIndex-- // 索引值-1
        this.imgUrlList.forEach((item, index) => { // 循环小图,通过判断索引值赋值给大图
          if (this.imgActiveIndex === index) {
            this.mainImgUrl = item
          }
        })
      }
      if (this.imgActiveIndex >= 4) {
        var index = 0
        const temp = window.setInterval(() => { // 利用定时器实现图片左右移动的动画效果
          if (index < 33) { // 移动次数(33次)
            this.imgDistance += 2 // 每次向左移动的距离 (移动总距离为33*this.imgDistance)
            index++
            return
          } else {
            window.clearInterval(temp) // 移动完清除定时器
          }
        }, 10)
      }
    },
    imgRight() {
      if (this.imgActiveIndex < this.imgUrlList.length - 1) {
        this.imgActiveIndex++
        this.imgUrlList.forEach((item, index) => {
          if (this.imgActiveIndex === index) {
            this.mainImgUrl = item
          }
        })
        if (this.imgActiveIndex >= 5) {
          this.allDistance = -66 * (this.imgActiveIndex - 4)
          var index = 0
          const temp = window.setInterval(() => {
            if (index < 33) {
              this.imgDistance -= 2 // 每次向右移动的距离
              index++
              return
            } else {
              window.clearInterval(temp)
            }
          }, 10)
        }
      } else if (this.imgActiveIndex === this.imgUrlList.length - 1) { // 到达最后一张图片，再点击跳转回第一张
        this.imgActiveIndex = 0;
        this.mainImgUrl = this.imgUrlList[0]
        var index = 0
        const temp = window.setInterval(() => { // 利用定时器实现图片左右移动的动画效果
          if (index < Math.abs(this.allDistance / 2)) { // 取绝对值再除
            this.imgDistance += 2 // 每次向左移动的距离 (移动总距离为33*this.imgDistance)
            index++
            return
          } else {
            window.clearInterval(temp) // 移动完清除定时器
          }
        }, 1)
      }
    },
    handleClick(tab, event) {
    },
    //在线咨询提交
    SubmitForm() {
      let that = this;
     that.$axios.post(api + '/site/onlineContact?deptId =' + 1, {
        emulateJSON: true
      }).then(function(res) {
        if (res.data.code == '0') {
          if (res.data.data) {
            that.$message.error(res.message);
            console.log('columnData', that.columnData)
          }
        } else {
          that.$message.error(res.message);
        }
      }) 
    },
    // 在线咨询弹窗
    openDialog() {
      this.zxDialog = true
    },
    handleClose(formName) {
      this.zxDialog = false
      this.bugDialog = false
      this.$nextTick(() => {
        this.$refs[formName].resetFields();
      })
    },
    // 栏目列表转树形结构
    handleTree(data, id, parentId, children) {
      let config = {
        id: id || 'id',
        parentId: parentId || 'parentId',
        childrenList: children || 'children'
      };

      var childrenListMap = {};
      var nodeIds = {};
      var tree = [];

      for (let d of data) {
        let parentId = d[config.parentId];
        if (childrenListMap[parentId] == null) {
          childrenListMap[parentId] = [];
        }
        nodeIds[d[config.id]] = d;
        childrenListMap[parentId].push(d);
      }

      for (let d of data) {
        let parentId = d[config.parentId];
        if (nodeIds[parentId] == null) {
          tree.push(d);
        }
      }

      for (let t of tree) {
        adaptToChildrenList(t);
      }

      function adaptToChildrenList(o) {
        if (childrenListMap[o[config.id]] !== null) {
          o[config.childrenList] = childrenListMap[o[config.id]];
        }
        if (o[config.childrenList]) {
          for (let c of o[config.childrenList]) {
            adaptToChildrenList(c);
          }
        }
      }

      return tree;
    },
    //列表
    zxSubmit() {
      let that = this;
      that.$axios.post(api + '/site/productList?columnId=' + this.queryParams.type + '&deptId=' + deptId
          + '&pageNum=' + this.queryParams.pageNum + '&pageSize=' + this.queryParams.pageSize
          + '&param=' + this.queryParams.gjz, {
        emulateJSON: true
      }).then(function (res) {
        if (res.data.code == '0') {
          if (res.data.data) {
            that.listData = res.data.data.rows
            that.total = res.data.data.total
            // console.log('列表', res.data.data.rows)
          }
        } else {
          that.$message.error(res.message);
        }
      })
    },
    //栏目列表
    lmList() {
      let that = this;
      that.$axios.post(api + '/site/columnList?deptId=' + deptId, {
        emulateJSON: true
      }).then(function (res) {
        if (res.data.code == '0') {
          if (res.data.data) {
            var arr = []
            res.data.data.forEach(item => {
              if (item.visible == 0) {
                arr.push(item)
              }
            })
            // console.log(222, arr);
            that.columnData = that.handleTree(arr, 'menuId', 'parentId')
            // console.log('columnData', that.columnData)
          }
        } else {
          that.$message.error(res.message);
        }
      })
    },
    // 外部链接
    wlList() {
      let that = this;
      that.$axios.post(api + '/site/outsideList?deptId=' + deptId, {
        emulateJSON: true
      }).then(function (res) {
        if (res.data.code == '0') {
          if (res.data.data) {
            // console.log(555, res.data.data)
            that.outsideList = res.data.data
          }
        } else {
          that.$message.error(res.message);
        }
      })
    },
    openUrl(item) {
      window.history.back();
      // window.location = "/#/cplist"
      // console.log(this.detailData)
    /*  window.location = '/#/cplist?id=' + 133 + '&name=' + this.detailData.menuName +
          '&index=' + this.$route.query.index + '&menuId=' + this.$route.query.menuId;*/

      /*console.log('item', item)
      if (item.menuName != "首页") {
        window.location = '/#/ejml?id=' + item.menuId + '&name=' + encodeURI(item.menuName);
        // window.location='/#/ejml?id=' + item.menuId
      } else {
        window.location = '/#/shouye';
      }*/
    },
    handleSelect(key, keyPath) {

    },
  }
}
</script>

<style scoped>
.el-button--success{
  background-color:#008C3E;
  border-color:#008C3E;
  width: 100%;
}
.active{
  color: #008D40;
  font-weight: 600;
  border-bottom: #0dcc73 solid 3px;
}
/*头部*/
.dqwz{
  line-height: 3;
  color: rgba(110,110,110,1);
  font-size:14px;
}
.cpb {
  padding: 15px 0;
  overflow: auto;
}

.cpbox:hover {
  border: solid 2px red;
}

.cpbox {
  border: solid 2px rgb(113, 113, 113);
  width: calc(100% / 4 - 35px);
  float: left;
  margin: 15px;
  cursor: pointer;
}

.cpimg {
  height: 280px;
  width: 100%;
}

.cpname {
  background-color: #F7F7F7;
  text-align: center;
  padding: 15px;
}

.xqbox {
  color: rgb(158, 159, 159);
  font-size: 12px;
}

.pleft {

}

/* 放大的图片，通过定位将左上角定位到(0,0) */
.rightImg {
  display: inline-block;
  width: 900px;
  height: 900px;
  position: absolute;
  top: 0;
  left: 0;
}

/* 右边的区域图片放大空间 */
.right {
  margin-left: 520px;
  margin-top: -550px;
  width: 400px;
  height: 400px;
  border: 1px solid red;
  position: relative;
  overflow: hidden;
}

/* 一个最高层层罩 */
.maskTop {
  width: 400px;
  height: 400px;
  position: absolute;
  z-index: 1;
  /* top: 1%;
  left: 0.6%; */
  top: 42%;
  left: 14%;
}

/* 层罩，通过定位将左上角定位到(0,0) */
.top {
  width: 200px;
  height: 200px;
  background-color: lightcoral;
  opacity: 0.4;
  position: absolute;
  /* top: 1%;
  left: 0.6%; */
  top: 42%;
  left: 14%;
}

/* 原图的显示 */
.leftImg {
  width: 400px;
  height: 400px;
  display: inline-block;
}

/* 原图的容器 */
.left {
  width: 400px;
  height: 400px;
  border: 1px solid teal;
  float: left;
  position: relative;
}

.Img_ul {
  position: relative;
  display: flex;
  width: 322px;
  height: 50px;
  overflow: inherit;
  list-style: none;
}

.Img_li {
  float: left;
  margin: 0 8px;
  cursor: pointer;
}

.img_activeBorder {
  border: 3px solid #0dcc73;
}

/* 产品详情 */
.cpxq {
  margin-top: 60px;
  padding-top: 60px;
  border-top: solid 1px #C6C6C6;
}
::v-deep.cpxq img{
  width: 100%;
}
.cpxqbox{
  padding: 15px 0;
  font-size: 18px;
  font-weight: 600;
}
.el-tabs--card > .el-tabs__header {
  border-bottom: 1px solid #303133;
}

.el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: 1px solid #303133;
  border-bottom: none;
}

/* 商品表单 */
.el-form-item__content {
  margin-left: 0 !important;
}

.biaodan {
  width: 45%;
  margin-left: 5%;
  padding: 15px;
}

h2 {
  text-align: center;
}

.el-form-item > .el-input {
  width: unset;
  width: 230px !important;
}

/* 商品轮播图 */
.el-carousel__button {
  background-image: url(../../static/img/0e25b5c4258a0ed852f4cd862ffbc160_27663_351_351.jpeg);
  background-size: 100% 100%;
  height: 30px;
  width: 30px;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}

.cpb {
  height: 30%;
  margin: 30px 0;
  display: flex;
}

.block {
  width: 40%;
  padding: 0 30px 0 0;
}


.col {
  color: #000000;
  border-bottom: solid 5px #0E58A5;
  width: 77%;
  margin: auto;
  height: 50px;
}

.lowerbox {
  padding: 25px;
  margin: 15px 0;
}

.ceneterbox {
  width: 90%;
  margin: auto;
  padding: 15px;
  /* margin-top: 1%!important; */
}

body,
html {
  height: 100%;
  margin: 0;
}

#app {
  /* height: 100%;
  width: 100%; */
  background: linear-gradient(to top, rgb(116, 173, 51) 0%, rgb(212, 229, 185) 100%);
  background-size: 100% 100%;
}
.el-dialog__wrapper {
  overflow: hidden;
}

.zxbox .el-dialog {
  left: 30% !important;
  margin-top: auto !important;
}

.zxbox .el-dialog__header {
  background-color: #009FED;
  padding: 0px;
}

.zxbox .el-dialog__title {
  color: #fff;
}

.zxbox .dialog-header-title {
  display: flex;
  border-radius: 10px;
}

.zxbox .el-dialog__close {
  color: #fff;
}

.zxbox {
  top: 35%;
}

.zxname {
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  line-height: 40px;
  padding: 0 5px;
  line-height: 50px;
}

.el-input {
  width: 84%;
}

.el-textarea {
  width: 84%;
}

.zxbox .el-form-item__content {
  text-align: center;
  padding: 5px;
}

.zxbox .el-form-item {
  margin-bottom: 0px;
}

 .el-form-item {
  text-align: center;
}

.el-popover,
.popper__arrow::after {
  padding: 0px;
  border-radius: 10px;
  background-color: rgb(0, 160, 233);
  border: 1px solid rgb(0, 160, 233)
}
.yzmbiaodan{
  width: calc(100% - 235px) !important;
}
@media screen and (max-width: 500px) {
  .cpb {
    display: block;
  }
  ::v-deep img{
    max-width:100%;
  }
  .block{
    width:90%;
    padding: 0 15px 0 15px;
  }
  .biaodan{
    width: 90%;
    margin-left:0;
  }
  .Img_ul{
    width: 280px;
  }
  ::deep.el-dialog{
    width: 100% !important;
  }

  .yzmbiaodan{
    width: calc(100% - 180px) !important;
  }
  .el-button--primary {
    color: #FFF;
    background-color: #409EFF;
    border-color: #409EFF;
    border-radius: 5px;
  }
}
</style>
